import { useBreakpoints } from '@vueuse/core'
import { DEVICE_TYPE } from '@/contants'
import { useGlobalStore } from '@/stores/globalStore.ts'

// { "xs": 480, "sm": 576, "md": 768, "lg": 992, "xl": 1200, "xxl": 1600 }
const breakpoints = useBreakpoints({
  sm: 576,
  md: 768,
  xl: 1200,
  xxl: 1400
})
export const isMobile = breakpoints.smaller('sm')
export const isTablet = breakpoints.between('md', 'xl')
export const isDesktop = breakpoints.between('xl', 'xxl')
export const isDesktopXl = breakpoints.greater('xxl')

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function triggerWindowResizeEvent() {
  const event: any = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

let clear: number | undefined
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const setDeviceType = () => {
  const globalStore = useGlobalStore()

  if (clear) {
    clearTimeout(clear)
  }
  clear = setTimeout(function () {
    triggerWindowResizeEvent()
    if (isMobile.value) {
      globalStore.setDevice(DEVICE_TYPE.MOBILE)
    }
    if (isTablet.value) {
      globalStore.setDevice(DEVICE_TYPE.TABLET)
    }
    if (isDesktop.value) {
      globalStore.setDevice(DEVICE_TYPE.DESKTOP)
    }
    if (isDesktopXl.value) {
      globalStore.setDevice(DEVICE_TYPE.DESKTOP_XL)
    }
  })
}
